import { styled } from "@theme/stitches.config"

export const Main = styled("main", {})
